import { render, staticRenderFns } from "./FormulateTooltip.vue?vue&type=template&id=67e39ea2&"
import script from "./FormulateTooltip.vue?vue&type=script&lang=js&"
export * from "./FormulateTooltip.vue?vue&type=script&lang=js&"
import style0 from "./FormulateTooltip.vue?vue&type=style&index=0&id=67e39ea2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports